import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 12,
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
  },
}));

export default useStyles;
